export const PERMISSION_BRANDS = {
  CREATE: 'BrandsModule.create',
  VIEW: 'BrandsModule.view',
  UPDATE: 'BrandsModule.update',
  DELETE: 'BrandsModule.delete',
};
